import { Location_Metrics_Mobile_Pay_Filter } from '@occc/graphql';

export const DEFAULT_TRANSACTION_SET = Location_Metrics_Mobile_Pay_Filter.All;

export const TRANSACTION_SET_OPTIONS: {
  label: string;
  value: Location_Metrics_Mobile_Pay_Filter;
}[] = [
  {
    label: 'All Transactions',
    value: Location_Metrics_Mobile_Pay_Filter.All,
  },
  {
    label: 'Mobile Pay Only',
    value: Location_Metrics_Mobile_Pay_Filter.MobilePayOnly,
  },
];
